import { getDomainValueForCode, isSchoolAdmin, recentPassoutYear } from "../../../library/Core/SmartFunctions";

const CardNoPreparingExam = ({ alumni, state }: { alumni: any; state: any }) => {
    console.log(alumni, ' alumni ');
    const recentPassoutyear=recentPassoutYear(alumni)
    return (
        <div key={alumni.uuid} className="alumni_univarsity_details examtaken">
            <div className="alumni_univarsity_details_inner_cover">
                <div className="alumni_univarsity_logo">
                    
                    <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/icon-note.svg" alt="" />
                </div>
                <div className="alumni_univarsity_brife">
                    <div className="alumni_education">
                        <div className="row g-2">
                            <div className="col">Taking A Break</div>
                        </div>
                    </div>
                    {alumni?.workingStatusCode === 'NOT_WORKING' ? (
                        <div className="alumni_univarsity_subject">
                            <i className=""></i>
                            <span>Not Working Now</span>
                        </div>
                    ) : (
                        !!alumni?.recentPassoutYear && (
                            <div className="alumni_univarsity_subject">
                                <i className=""></i>
                                <span>Since {alumni.recentPassoutYear}</span>
                            </div>
                        )
                    )}
                 
                </div>
            </div>
        </div>
    );
};

export default CardNoPreparingExam;
